module.exports = __webpack_public_path__ + "static/img/day3.77bd5f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour1/day3.jpg
// module id = S8cE
// module chunks = 0